/** What a reading means for the member, in words they would use about themselves. */
export const READING_MEANING = {
    sleep_hours: {
        under: "You slept less than you usually do",
        in: "You slept about as long as you usually do",
        over: "You slept longer than you usually do",
    },
    efficiency: {
        under: "You slept less solidly than you usually do",
        in: "You slept about as solidly as you usually do",
        over: "You slept more solidly than you usually do",
    },
    rem: {
        under: "You got less dreaming sleep than you usually do",
        in: "You got about as much dreaming sleep as you usually do",
        over: "You got more dreaming sleep than you usually do",
    },
    hrv: {
        under: "You recovered less overnight than you usually do",
        in: "You recovered overnight about as much as you usually do",
        over: "You recovered more overnight than you usually do",
    },
    rhr: {
        under: "Your heart worked less hard at rest than it usually does",
        in: "Your heart worked about as hard at rest as it usually does",
        over: "Your heart worked harder at rest than it usually does",
    },
    spo2: {
        under: "Your blood oxygen sat lower overnight than it usually does",
        in: "Your blood oxygen sat about where it usually does overnight",
        over: "Your blood oxygen sat higher overnight than it usually does",
    },
    breathing: {
        under: "You breathed more slowly at rest than you usually do",
        in: "You breathed about as fast at rest as you usually do",
        over: "You breathed faster at rest than you usually do",
    },
    skin_temp: {
        under: "You ran cooler overnight than you usually do",
        in: "You ran about as warm overnight as you usually do",
        over: "You ran warmer overnight than you usually do",
    },
    steps: {
        under: "You have moved less than you usually do",
        in: "You have moved about as much as you usually do",
        over: "You have moved more than you usually do",
    },
    // Moderate and vigorous minutes, not time on your feet: an easy walking day
    // moves the two in opposite directions, and this used to call that a drop.
    active_min: {
        under: "You have worked at a moderate effort for less of the day than you usually do",
        in: "You have worked at a moderate effort for about as much of the day as you usually do",
        over: "You have worked at a moderate effort for more of the day than you usually do",
    },
    trained: {
        under: "You have logged less workout time than you usually do",
        in: "You have logged about as much workout time as you usually do",
        over: "You have logged more workout time than you usually do",
    },
    stress_time: {
        under: "You have spent less of the day stressed than you usually do",
        in: "You have spent about as much of the day stressed as you usually do",
        over: "You have spent more of the day stressed than you usually do",
    },
    stress_load: {
        under: "Your stress has been lower than it usually is",
        in: "Your stress has been about where it usually is",
        over: "Your stress has been higher than it usually is",
    },
    weight: {
        under: "You are below your usual range",
        in: "You are inside your usual range",
        over: "You are above your usual range",
    },
    // `as const` so a caller naming a row it depends on gets the string itself rather than `string | null`, which is what made one branch carry a second, already-divergent copy of the row it was falling back from.
};
/** The plain read of a term on one side of the member's usual, when it has one. */
export function readingMeaning(termKey, verdict) {
    if (!termKey || !verdict)
        return null;
    const row = READING_MEANING[termKey];
    return row?.[verdict] ?? null;
}
//# sourceMappingURL=reading-meaning.js.map